export const SKINS = [
  "color",
  "dark",
  "mono",
  "matrix",
  "dracula",
  "alien",
  "y2k",
  "neoy2k",
  "aquarium",
  "winamp",
  "macos",
];

export const SKIN_LABELS = {
  // The default look. Named "None" so it reads as "no skin applied",
  // matching the None that leads Moods. The stored value stays `color`.
  color: "None",
  // slowed.app's dark theme: black page, the same pinks.
  dark: "Dark",
  // The grey look that was called Dark until 0.12.0. The stored value never
  // changed, so anyone who picked it keeps it, under its new name.
  mono: "Mono",
  winamp: "Winamp 2.0",
  macos: "Classic Mac",
  y2k: "Y2K",
  neoy2k: "Neo-Y2K",
  matrix: "Matrix",
  aquarium: "Aquarium",
  dracula: "Dracula",
  alien: "Alien",
};

export function resolveSkin(config) {
  // A stored skin that is no longer offered falls back to the default.
  if (config?.skinPreference) {
    return SKINS.includes(config.skinPreference)
      ? config.skinPreference
      : "color";
  }

  // Pre-skin installs stored a binary light/dark preference. Their dark was
  // the grey look, which is Mono now.
  if (config?.darkModePreference === "dark") return "mono";
  if (config?.darkModePreference === "light") return "color";
  if (config?.darkMode === true) return "mono";

  return "color";
}

// The skin the panel is wearing right now: `config.skin`, which is the
// preference unless a lapsed trial forced the default (config/index.js).
// Product metrics tag events with it, so GA4 can rank the skins in use.
export function appliedSkin(config) {
  if (!config) return "color";
  return resolveSkin(config.skin ? { skinPreference: config.skin } : config);
}

export function nextSkin(skin) {
  const index = SKINS.indexOf(skin);
  return SKINS[(index + 1) % SKINS.length];
}
